import React from 'react';
import PropTypes from "prop-types";
import ChatGroup from "./ChatGroup";
import { getDateFromUTCString } from 'utils/time';

const DATE_FORMAT_STR = 'MMM-D-YYYY';

function ChatGroups({ messages, patientId }) {
  const days = messages
    .map(message => getDateFromUTCString(message.createdAt).format(DATE_FORMAT_STR))
    .filter((value, index, self) => self.indexOf(value) === index);

  let groups = [];
  days.forEach(function groupMessagesByDay(day) {
    const messagesOnDay = messages.filter(message => getDateFromUTCString(message.createdAt).format(DATE_FORMAT_STR) === day);
    groups.push(messagesOnDay);
  });

  return groups.map((group, i) => {
    const [mon, day, yr] = days[i].split('-');
    const fmtDate = `${mon} ${day}, ${yr}`;
    return <ChatGroup key={fmtDate} header={fmtDate} messages={group} patientId={patientId} />
    }
  )
}

ChatGroups.propTypes = {
  messages: PropTypes.array.isRequired,
  patientId: PropTypes.string.isRequired,
};

export default ChatGroups;
